import className from 'classnames/bind';
import { Container, Heading } from '@/components';
import styles from './PostsHero.module.scss';

let cx = className.bind(styles);

export function PostsHero({ children, title, className }) {
  const classNameArray = className?.split(' ') || [];

	return (
		<section className={cx(['ns_posts-hero', 'posts-hero', ...classNameArray])}>
			<Container>
				{title && (
					<Heading level="h2" className={cx(['posts-title'])}>
						{title}
					</Heading>
				)}
				{children}
			</Container>
		</section>
	);
}
